<template>
  <div class="paywall">
    <div class="paywall-inner">
      <p class="label">Pay wall</p>
    </div>
    <button class="btn-orange" @click="$emit('done')">AVANÇAR</button>
  </div>
</template>

<script>
export default { name: "OStep6" };
</script>

<style scoped lang="scss">
.paywall       { display: flex; flex-direction: column; align-items: center; gap: 24px; width: 100%; max-width: 500px; }
.paywall-inner { width: 100%; aspect-ratio: 16/9; background: rgba(255,130,93,.7); border-radius: 16px; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(8px); }
.label         { font-size: 20px; font-weight: 700; color: #fff; }
.btn-orange    { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #ff825d; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; box-shadow: 0 4px 16px rgba(255,130,93,.35); &:hover { background: #e86b45; } }
</style>
